import React, { Component } from "react";
import ModalFrame from "../../../../../toolkit/modalFrame";
import { DeportivaComisionInfo } from "../../../../../types/DeportivaComisionLog";

interface Props {
  info: DeportivaComisionInfo;
  open: boolean;
  onClose: () => void;
}

interface State {}

export default class DAutorizacionLog extends Component<Props, State> {
  state = {};

  formatDate = (mysqlDate: string): string => {
    if (!mysqlDate) {
      return "-";
    }

    try {
      const [date, time] = mysqlDate.split(" ");
      const [year, month, day] = date.split("-");

      // Formato de la fecha:
      const fmtDate = `${day}/${month}/${year} `;
      const indexSeconds = time.lastIndexOf(":");
      const fmtTime =
        indexSeconds >= 4 ? time.substring(0, indexSeconds) : time;

      return fmtDate + fmtTime;
    } catch (error) {
      return mysqlDate;
    }
  };

  render() {
    const { info, open, onClose } = this.props;

    if (!open) {
      return null;
    }

    const logsTable = info.logs.filter(l => !l.autorizacion);
    const autorizacion = info.logs.find(l => l.autorizacion);

    return (
      <ModalFrame
        title="Logs de comisión"
        isOpen={open}
        toggle={onClose}
        size="lg"
      >
        <div>
          <div className="modal-body">
            {autorizacion ? (
              <div className="alert alert-success" role="alert">
                Comisión autorizada por {autorizacion.usuario} el{" "}
                {autorizacion.fecha}
              </div>
            ) : (
              <div className="alert alert-info" role="alert">
                La comisión no ha sido autorizada
              </div>
            )}
            <table hidden={!logsTable.length} className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Fecha</th>
                  <th scope="col">No. Empleado</th>
                  <th scope="col">Empleado</th>
                  <th scope="col">Acción</th>
                </tr>
              </thead>
              <tbody>
                {logsTable.map((log, index) => (
                  <tr key={index}>
                    <td>{this.formatDate(log.fecha)}</td>
                    <td>{log.numeroEmpleado}</td>
                    <td>{log.usuario}</td>
                    <td>{log.accion}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div
              style={{
                textAlign: "right",
                fontSize: "10px",
                fontWeight: "bold"
              }}
            >
              *{info.descripcion}
            </div>
          </div>
        </div>
      </ModalFrame>
    );
  }
}
